import { render } from "./zygd.vue?vue&type=template&id=72f6ef78&scoped=true&ts=true"
import script from "./zygd.vue?vue&type=script&lang=ts"
export * from "./zygd.vue?vue&type=script&lang=ts"

import "./zygd.vue?vue&type=style&index=0&id=72f6ef78&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f6ef78"]])

export default __exports__